import { useEffect, useState } from "react";
import "./ProjectsPage.css";

import riverstoneResidence from "../assets/riverstone-residence.jpg";
import riverstoneResidence2 from "../assets/ardra-wardrobe-system.jpg";
import graphiteKitchen from "../assets/graphite-kitchen.jpg";
import atelierApartment from "../assets/atelier-apartment.jpg";
import panelGrain from "../assets/aurangabad-house/warm-living-tv-unit1.png";
import heroCantilever from "../assets/hero_cantilever.jpg";
import waterCourt from "../assets/water_court.jpg";
import livingRoom from "../assets/living_room.jpg";
import warmKitchen from "../assets/warm-kitchen.png";
import bedroomStudy from "../assets/bedroom-study.png";
import warmLiving from "../assets/warm-living-tv-unit.jpeg";

import commercialProjectCard from "../assets/comarcial-project/Enscape_2025-01-20-13-50-11.png";
import commercialProjectHero from "../assets/comarcial-project/Enscape_2025-01-20-13-50-11.png";

import upcomingProjectHero from "../assets/upcoming-project-image/living and dinning1.png";
import upcomingProjectCard from "../assets/upcoming-project-image/living and dinning1.png";


// Shinde House images
import shindeHouse from "../assets/shinde-house/shinde house c bed.png";

// The Stellar Homes images
import stellarHomes from "../assets/pranav-khot-house/orchid-living-33.png";

// Bunglow Interior images
import bungalowInterior from "../assets/aurangabad-house/ChatGPT Image Sep 4, 2026, 05_50_02 PM.png";

const PROJECTS = [

  {
    slug: "upcoming-residential-project",
    src: upcomingProjectHero,
    alt: "Upcoming residential interior project living and dining area",
    featured: "Upcoming Residential Project",
    location: "Pune",
    area: "In planning",
    category: "Interior",
    status: "Upcoming",
    year: "Upcoming",
    description: "An upcoming residential interior with living, dining, kitchen and bedroom spaces.",
  },
  
  {
    slug: "stellar-homes",
    src: stellarHomes,
    alt: "The Stellar Homes apartment interior",
    featured: "The Stellar Homes",
    location: "Wakad / Pune",
    area: "00,750 SQ.FT.",
    category: "Interior",
    status: "Completed",
    year: "2026",
    description: "A compact 2BHK apartment designed with optimal space utilization and contemporary style.",
  },
  {
    slug: "bunglow-interior",
    src: bungalowInterior,
    alt: "Bunglow Interior design",
    featured: "Bunglow Interior",
    location: "Vaijapur",
    area: "02,500 SQ.FT.",
    category: "Interior",
    status: "Completed",
    year: "2026",
    description: "A comprehensive 4BHK bunglow interior with thoughtful design and comfortable living spaces.",
  },

 {
    slug: "shinde-house",
    src: shindeHouse,
    alt: "Shinde House renovation",
    featured: "Shinde House",
    location: "Nigadi Pradhikaran / Pune",
    area: "02,200 SQ.FT.",
    category: "Interior",
    status: "Completed",
    year: "2026",
    description: "A complete 3BHK bunglow renovation including bathroom, electrical work, and modern furnishings.",
  },

  {
    slug: "up-coming-project",
    src: commercialProjectHero,
    alt: "Upcoming commercial interior project in Wakad",
    featured: "Commercial Project",
    location: "Wakad",
    area: "450 SQ.FT.",
    category: "Commercial Interior",
    status: "Upcoming",
    year: "Upcoming",
    description: "A compact commercial interior project planned for Wakad.",
  },
 

  {
    slug: "riverstone-residence",
    src: riverstoneResidence2,
    alt: "Riverstone Residence apartment interior",
    featured: "Riverstone Residence",
    location: "Baner / Pune",
    area: "01,850 SQ.FT.",
    category: "Interior",
    status: "Completed",
    year: "2026",
    description: "A sophisticated 4BHK apartment interior with modern aesthetics and refined finishes.",
  },

];

const GALLERY_PROJECTS = [
  {
    number: "01",
    slug: "shinde-house",
    title: "Shinde House",
    category: "Interior",
    location: "Nigadi Pradhikaran / Pune",
    year: "2026",
    src: shindeHouse,
    alt: "Shinde House interior renovation",
  },
  {
    number: "02",
    slug: "stellar-homes",
    title: "The Stellar Homes",
    category: "Interior",
    location: "Wakad / Pune",
    year: "2026",
    src: stellarHomes,
    alt: "The Stellar Homes apartment interior",
  },
  {
    number: "03",
    slug: "bunglow-interior",
    title: "Bunglow Interior",
    category: "Interior",
    location: "Vaijapur",
    year: "2026",
    src: bungalowInterior,
    alt: "Bunglow Interior design",
  },
  {
    number: "04",
    slug: "riverstone-residence",
    title: "Riverstone Residence",
    category: "Interior",
    location: "Baner / Pune",
    year: "2026",
    src: riverstoneResidence,
    alt: "Riverstone Residence apartment",
  },
  /* FUTURE PROJECT - The Limestone Residence
  Uncomment this full block when you want to show The Limestone Residence again.
  {
    number: "05",
    slug: "limestone-residence",
    title: "The Limestone Residence",
    category: "Architecture",
    location: "Jaipur / India",
    year: "2024",
    src: heroCantilever,
    alt: "Modern limestone residence exterior",
  },
  */
  /* FUTURE PROJECT - White Court House
  Uncomment this full block when you want to show White Court House again.
  {
    number: "06",
    slug: "white-court-house",
    title: "White Court House",
    category: "Architecture",
    location: "Pune / India",
    year: "2025",
    src: waterCourt,
    alt: "Minimal white courtyard house",
  },
  */
  /* FUTURE PROJECT - Monochrome Residence
  Uncomment this full block when you want to show Monochrome Residence again.
  {
    number: "07",
    slug: "monochrome-residence",
    title: "Monochrome Residence",
    category: "Interior",
    location: "Mumbai / India",
    year: "2025",
    src: livingRoom,
    alt: "Monochrome interior living space",
  },
  */
  /* FUTURE PROJECT - Concrete & Wood
  Uncomment this full block when you want to show Concrete & Wood again.
  {
    number: "08",
    slug: "concrete-and-wood",
    title: "Concrete & Wood",
    category: "Architecture",
    location: "Lonavala / India",
    year: "2024",
    src: panelGrain,
    alt: "Concrete and wood architectural detail",
  },
  */
  /* FUTURE PROJECT - Graphite Kitchen
  Uncomment this full block when you want to show Graphite Kitchen again.
  {
    number: "09",
    slug: "graphite-kitchen",
    title: "Graphite Kitchen",
    category: "Interior",
    location: "Pune / India",
    year: "2026",
    src: graphiteKitchen,
    alt: "Graphite kitchen project",
  },
  */
  
  /* FUTURE PROJECT - Warm Stone Home
  Uncomment this full block when you want to show Warm Stone Home again.
  {
    number: "10",
    slug: "warm-stone-home",
    title: "Warm Stone Home",
    category: "Residential",
    location: "Baner / India",
    year: "2026",
    src: riverstoneResidence,
    alt: "Warm stone home interior",
  },
  */
  /* FUTURE PROJECT - Atelier Minimal
  Uncomment this full block when you want to show Atelier Minimal again.
  {
    number: "11",
    slug: "atelier-minimal",
    title: "Atelier Minimal",
    category: "Residential",
    location: "Koregaon / India",
    year: "2026",
    src: atelierApartment,
    alt: "Minimal apartment interior",
  },
  */
  /* FUTURE PROJECT - Quiet Geometry
  Uncomment this full block when you want to show Quiet Geometry again.
  {
    number: "12",
    slug: "quiet-geometry",
    title: "Quiet Geometry",
    category: "Interior",
    location: "Goa / India",
    year: "2026",
    src: warmKitchen,
    alt: "Quiet geometric interior",
  },
  */
  /* FUTURE PROJECT - Earth Residence
  Uncomment this full block when you want to show Earth Residence again.
  {
    number: "13",
    slug: "earth-residence",
    title: "Earth Residence",
    category: "Interior",
    location: "Udaipur / India",
    year: "2025",
    src: bedroomStudy,
    alt: "Earth toned bedroom interior",
  },
  */
  /* FUTURE PROJECT - Frame House
  Uncomment this full block when you want to show Frame House again.
  {
    number: "14",
    slug: "frame-house",
    title: "Frame House",
    category: "Interior",
    location: "Alibaug / India",
    year: "2026",
    src: warmLiving,
    alt: "Warm framed living room",
  },
  */
  {
    number: "15",
    slug: "up-coming-project",
    title: "Commercial Project",
    category: "Commercial Interior",
    location: "Wakad",
    year: "Upcoming",
    src: commercialProjectCard,
    alt: "Upcoming commercial interior project in Wakad",
    area: "450 Sq.ft",
  },
  {
    number: "16",
    slug: "upcoming-residential-project",
    title: "Upcoming Residential Project",
    category: "Interior",
    location: "Pune",
    year: "Upcoming",
    src: upcomingProjectCard,
    alt: "Upcoming residential interior project living and dining area",
    area: "In planning",
  },
];

const FILTERS = ["All", "Architecture", "Interior", "Commercial Interior"];

export default function ProjectsPage() {
  const [active, setActive] = useState(0);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % PROJECTS.length);
    }, 3600);

    return () => clearInterval(id);
  }, []);

  const current = PROJECTS[active];
  const visibleProjects =
    filter === "All"
      ? GALLERY_PROJECTS
      : GALLERY_PROJECTS.filter((project) => project.category === filter);

  return (
    <>
      <section className="projects-hero-auto" aria-label="Projects">
        <div className="projects-hero-auto-media">
          {PROJECTS.map((project, index) => (
            <img
              key={project.slug}
              src={project.src}
              alt={project.alt}
              className={index === active ? "projects-hero-auto-is-visible" : ""}
              loading={index === 0 ? "eager" : "lazy"}
            />
          ))}
        </div>

        <div className="projects-hero-auto-scrim" />

        <div className="projects-hero-auto-grid" aria-hidden="true">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <span key={i} style={{ animationDelay: `${0.3 + 0.09 * i}s` }} />
          ))}
        </div>

        <div className="projects-hero-auto-wrap projects-hero-auto-content">
          <p className="projects-hero-auto-kicker">Projects</p>
          <h1 className="projects-hero-auto-title">
            {/* <span>
              <i>Interiors in progress,</i>
            </span>
            <span className="projects-hero-auto-italic">
              <i>and interiors complete.</i>
            </span> */}

<span>  Designed here.  </span>
<span className="projects-hero-auto-italic">
              <i>Built by specialists.</i>
            </span> 

          </h1>

          <div className="projects-hero-auto-foot" key={current.slug}>
            <div className="projects-hero-auto-meta projects-hero-auto-fade projects-hero-auto-delay-2">
              <div>
                <p>Featured</p>
                <b>{current.featured}</b>
              </div>
              <div>
                <p>Location</p>
                <b>{current.location}</b>
              </div>
              <div>
                <p>Area</p>
                <b>{current.area}</b>
              </div>
            </div>

            <div className="projects-hero-auto-fade projects-hero-auto-delay-3">
              {/* <p className="projects-hero-auto-lede">{current.description}</p> */}
              {/* <a href="#project-gallery">
                <span className="projects-hero-auto-btn">
                  <span>View selected work</span>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 16 16"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M1 1L15 15M15 15H5M15 15V5"
                      stroke="currentColor"
                      strokeWidth="1.2"
                    />
                  </svg>
                </span>
              </a> */}
            </div>
          </div>
        </div>
      </section>

      <section className="project-index" id="project-gallery">
        <div className="project-index-filterbar">
          <div className="project-index-filters" aria-label="Project filters">
            {FILTERS.map((item) => (
              <button
                key={item}
                type="button"
                aria-pressed={filter === item}
                onClick={() => setFilter(item)}
              >
                {item}
              </button>
            ))}
          </div>
          <p>{String(visibleProjects.length).padStart(2, "0")} Projects</p>
        </div>

        <div className="project-index-grid">
          {visibleProjects.map((project) => (
            <article className="project-index-card" key={`${project.number}-${project.title}`}>
              <a href={`/${project.slug}`} aria-label={`Open ${project.title}`}>
                {/* <span className="project-index-number">{project.number}</span> */}
                <img src={project.src} alt={project.alt} loading="lazy" />
              </a>
              <div
                className="project-index-card-foot"
                role="link"
                tabIndex={0}
                onClick={(event) => {
                  if (event.target.closest("a")) return;
                  window.location.href = `/${project.slug}`;
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    window.location.href = `/${project.slug}`;
                  }
                }}
              >
                <h2>{project.title}</h2>
                <a
                  className="project-index-arrow"
                  href={`/${project.slug}`}
                  aria-label={`Open ${project.title}`}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 16 16"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M1 15L15 1M15 1H5M15 1V11"
                      stroke="currentColor"
                      strokeWidth="1.2"
                    />
                  </svg>
                </a>
                <p>
                  <span>{project.category}</span>
                  <span>{project.location}</span>
                  <span>{project.area || project.year}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
